import React from 'react';
import styled from 'styled-components';
import { sectionMargins } from '../styles';
import { Container } from './ui';
import TrustpilotWidget from './TrustpilotWidget';

const StyledReviewsGrid = styled.section`
  ${sectionMargins()};
`;

const ReviewsGrid = () => (
  <StyledReviewsGrid>
    <Container>
      <TrustpilotWidget type="grid" />
    </Container>
  </StyledReviewsGrid>
);

export default ReviewsGrid;
